import axios, { AxiosResponse } from 'axios' 
import { IGeneralTariffModel } from './GeneralTariffModel'
import { ApiResponse, PageResponse } from '../../../../shared/models/ApiModels'


const API_URL = (process.env.REACT_APP_API_URL || '/').replace(/\/?$/, '/')

export const GENERALTARIFF_CREATE_URL = `${API_URL}api/v1/definition/generalRate/create`
export const GENERALTARIFF_GET_ALL_URL = `${API_URL}api/v1/definition/generalRate/all`
export const GENERALTARIFF_DELETE_URL = `${API_URL}api/v1/definition/generalRate/delete/`
export const GENERALTARIFF_UPDATE_URL = `${API_URL}api/v1/definition/generalRate/update/`

export function createGeneralTariff(generalTariff: IGeneralTariffModel) {
  return axios.post(GENERALTARIFF_CREATE_URL, generalTariff)
}

export async function loadGeneralTariffs(
  page = 0, 
  size = 5, 
  sort: string = 'createdDate', 
  order: string = 'desc'
): Promise<AxiosResponse<ApiResponse<PageResponse<IGeneralTariffModel>>>> {
  return axios.get(GENERALTARIFF_GET_ALL_URL, {
    params: { page, size, sort, order }
  });
}

export function deleteGeneralTariff(generalTariffId: String) {
  return axios.delete(GENERALTARIFF_DELETE_URL + generalTariffId)
}

export function updateGeneralTariff(generalTariff: IGeneralTariffModel) {
  return axios.patch(GENERALTARIFF_UPDATE_URL + generalTariff.id, generalTariff)
}

 